import React from "react"

export default function Mybutton(props) {
  return <button className="btn bg-primary bg-gradient text-white btn-md mr-2">{props.name}</button>
}
